import { Button, Radio, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import Spin from 'components/modules/Spin';
import BaseForm from 'components/modules/BaseForm';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useCreateAdminUserManagement } from '../hooks/useCreateAdminUserManagement';
import { useViewAdminUserManagement } from '../hooks/useViewAdminUserManagement';
import moment from 'moment';

const Form = BaseForm;

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 12 },
        md: { span: 12 },
        xl: { span: 8 },
        xxl: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
        md: { span: 12 },
        xl: { span: 16 },
        xxl: { span: 18 },
    },
};

type Props = {
    tabActiveKey: string;
    hasTouchScreen: boolean;
};

const AdminUserManagementCard: React.FC<Props> = ({ tabActiveKey, hasTouchScreen }) => {
    const [form] = Form.useForm();
    const [isDisabledButtonSubmit, setIsDisabledButtonSubmit] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [createState, createRequest] = useCreateAdminUserManagement();
    const [viewState, viewRequest, resetView] = useViewAdminUserManagement();

    useEffect(() => {
        if (tabActiveKey !== 'settings') return;

        resetView();
        setIsDisabledButtonSubmit(true);
        viewRequest();
        form.setFieldsValue({
            isEnabled: false,
        });
        setIsLoading(true);
    }, [tabActiveKey]);

    useEffect(() => {
        if (viewState?.payload?.is_successful && !viewState.isLoading) {
            form.setFieldsValue({
                isEnabled: viewState.payload.result?.is_enabled ?? false,
            });
        }
        setIsLoading(viewState.isLoading);
        setIsDisabledButtonSubmit(true);
    }, [viewState]);

    useEffect(() => {
        if (createState?.payload?.is_successful && !createState.isLoading) {
            setIsLoading(true);
            viewRequest();
        }
    }, [createState]);

    const handleFinish = (values: any) => {
        createRequest(values.isEnabled);
    };

    const handleSubmit = () => {
        form.submit();
    };

    return (
        <div className='card' style={{ marginBottom: '32px', padding: '32px' }}>
            {isLoading ? (
                <div className='flex-center-container' style={{ height: '200px' }}>
                    <Spin />
                </div>
            ) : (
                <div>
                    <p className='gutter-bottom text-lg' style={{ fontWeight: 'bold' }}>
                        利用者管理と学校管理の機能制限
                    </p>
                    <span className='gutter-bottom' style={{ fontWeight: 'bold' }}>
                        利用者管理と学校管理の機能の利用を制限します。制限が有効の場合、教員以上の権限を持つ全ユーザーで、ユーザー情報の新規登録、編集、削除を行えません。
                    </span>
                    <br />
                    <p className='gutter-bottom'>
                        ※注意:「変更」ボタンを押すまで、変更は完了しません。
                    </p>

                    <Form
                        {...formItemLayout}
                        form={form}
                        name='control-hooks-edit-user'
                        onFinish={handleFinish}
                    >
                        <Form.Item
                            label={
                                <span>
                                    利用者管理と学校管理の機能制限
                                    <Tooltip title='利用者管理（全体・学校管理画面）、学校管理（全体管理画面）の新規登録・編集・削除ボタンがグレーアウトされ、操作が制限されます。'>
                                        <QuestionCircleOutlined className='icon-l' />
                                    </Tooltip>
                                </span>
                            }
                            name='isEnabled'
                            required
                        >
                            <Radio.Group
                                onChange={() => setIsDisabledButtonSubmit(!isDisabledButtonSubmit)}
                            >
                                <Radio value={true}>有効</Radio>
                                <Radio value={false}>無効</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Form>
                </div>
            )}
            <p style={{ color: 'red' }}>
                ※以前の設定日時：
                {viewState?.payload?.result?.updated_at
                    ? moment.unix(viewState?.payload?.result?.updated_at).format('YYYY/MM/DD HH:mm')
                    : 'なし'}
            </p>

            <div className='flex-right-container'>
                <Button
                    className='mb-4'
                    type='primary'
                    onClick={handleSubmit}
                    disabled={isDisabledButtonSubmit}
                >
                    変更
                </Button>
            </div>
        </div>
    );
};

export default AdminUserManagementCard;
